export const MAIN_URL = '/'
export const SERVICE_URL = '/service'
export const GAMES_URL = '/game'
export const ERROR_URL = '/error'
export const SUCCESS_URL = '/success'
export const SINGIN_URL = '/login'
export const REGISTER_URL = '/registrate'
export const CONTACT_URL = '/contact'
export const PROFILE_URL = '/profile'
export const FINANCE_URL = '/finance'
export const ORDER_URL = '/order'
export const COMFIRM_URL = '/confirm'
export const COMUNITY_URL = '/comunity'
export const BUY_URL = '/buy'
export const SETTINGS_URL = '/settings'
export const USER_URL = '/user'